import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PressUserState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PressUserQuery extends QueryEntity<PressUserState> {

  constructor(protected store: Store) {
    super(store);
  }

}
